/**
 * Deprecation method identifiers
 */
export enum DeprecationMethodId {
  StraightLineDeprecation = 1,
  ReducingBalanceMethod = 2
}

/**
 * Deprecation plan from backend
 */
export interface DeprecationPlan {
  id: number
  balanceSheetRowId: number
  deprecationMethodId: DeprecationMethodId
  value: number
  createdAt: string
  updatedAt: string
}

/**
 * Payload for creating/updating deprecation plan
 */
export interface DeprecationPlanPayload {
  balanceSheetRowId: number
  deprecationMethodId: DeprecationMethodId
  value: number
}
